import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import StripBanner from "@/components/ui/strip-banner";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { getEnumTKey } from "@/utils/strings";

interface Props {
  entityType: EntityType;
  className?: string;
  onDismiss: () => void;
}

// Processing strip above the Detailed view header; the parent owns dismissal.
const TranscriptProcessingBanner: React.FC<Props> = ({
  entityType,
  className,
  onDismiss
}) => {
  const { t } = useTranslation();

  const objectType = t(
    getEnumTKey("entities", "names", EntityType, entityType)
  );

  return (
    <StripBanner
      as="output"
      className={className}
      onDismiss={onDismiss}
      dismissLabel={t("close")}
      data-test="transcript-processing-banner"
    >
      <Text variant="body" className="text-center">
        {t("activities.transcript.processingBannerTitle", { objectType })}
      </Text>
    </StripBanner>
  );
};

export default TranscriptProcessingBanner;
